<template id="Dashboard">
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col lg="3" md="3" cols="12" v-for="(item, index) in getNavbarItems" :key="index">
                    <v-card color="primary" class="pa-3" @click="goTo('/module/'+item.prefix)">
                        <v-card-title class="pa-0 ma-0">
                            <v-btn density="comfortable" size="small"   variant="tonal" color="blue-grey-lighten-4" :icon="item.icon"></v-btn>
                            <div class="mt-2"><span class="text-subtitle-1 font-weight-medium">{{item.name}}</span></div>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import {useStore} from 'vuex';

export default {
        components: {
            breadCrumbs,
        },
        name: 'Dashboard',
        data: () => ({
            loading:false,
            form_loading: false,
            errorMessages:'',
            search: "",
            options: {
                chart: {
                id: 'vuechart-example'
                },
                xaxis: {
                categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
                }
            },
            series: [{
                name: 'series-1',
                data: [30, 40, 45, 50, 49, 60, 70, 91]
            }]
        }),

        watch: {
        },
        created(){
            // this.form_loading = true;
        //     this.$store.dispatch('getDashboardList').then(data => {
        //         this.form_loading = false;
        //    });
        },
        computed:{
            getSchema() {
                return this.$store.getters.getMenuList;
            },
            getNavbarItems(){
                return this.$store.getters.getNavbarItems
            }
        },
        methods: {
            clear(){

            },
            goTo(val) {
                this.$router.push({ path: val }).catch(err => {});
            },
            getDataFromApi(){
                this.loading = true;
                this.$store.dispatch('getMenuList')
                .then(data => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    toast.error(error.response.data.message); 
                })
                .then(always => {
                    this.loading = false;
                })
            },

        },

        mounted() {
            // this.getDataFromApi();
          }  
    }
</script>